import * as Analytics from 'expo-firebase-analytics';

export { Analytics };
